import React from 'react';
import PubSub from 'pubsub-js';
import Utility from '../../jsx/utility/utility';
import Auth from '../functions/authenticate';

// Progressive loading base class.
//
// Unlike BaseDataViewComponentAsync (which blocks rendering behind a
// full-page <Loader /> until ALL data fetches complete), this class
// renders the page shell immediately and exposes per-section loading
// state so each section can show its own skeleton or spinner.
//
// Subclass contract:
//   - Override fetchSections() to return an object where each key is a
//     section name and each value is a Promise that resolves to the data.
//   - In render(), read this.state[sectionName] for { loading, data, error }.
//   - The page shell renders immediately with loading=true for all sections.
//
// Example:
//   fetchSections() {
//       return {
//           activity: service.paginate(...).getAsync(),
//           utm: utmService.paginate(...).getAsync()
//       };
//   }
//   render() {
//       const { activity, utm } = this.state;
//       return (
//           <div>
//               {activity.loading ? <Skeleton /> : <ActivityGrid data={activity.data.items} />}
//               {utm.loading ? <Skeleton /> : <UtmGrid data={utm.data.items} />}
//           </div>
//       );
//   }

export default class BaseProgressiveView extends React.Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this._fetching = false;
    this._needsRefetch = false;
    this.state = {
      _authed: false
    };
  }
  async componentDidMount() {
    this._mounted = true;
    this._subscriber();
    Utility.fireEvent('app-layout-close-drawer', {});
    if (Auth.isAuthenticated()) {
      this.setState({
        _authed: true
      });
      this._startFetch();
    } else if (await Auth.attachOrSignIn()) {
      this.setState({
        _authed: true
      });
      this._startFetch();
    }
    // else: attachOrSignIn navigated to /Auth/SignIn
  }
  componentDidUpdate(prevProps) {
    if (this._needsRefetch) {
      this._needsRefetch = false;
      this._startFetch();
    }
  }
  componentWillUnmount() {
    this._mounted = false;
  }
  _subscriber() {
    PubSub.subscribe('search', () => {});
    PubSub.subscribe('allow-update', () => {
      this._needsRefetch = true;
      if (this._mounted) this.forceUpdate();
    });
  }
  _startFetch() {
    if (this._fetching) return;
    this._fetching = true;
    const sections = this.fetchSections();
    if (!sections) {
      this._fetching = false;
      return;
    }
    const entries = Object.entries(sections);
    let pending = entries.length;
    for (const [name, promise] of entries) {
      Promise.resolve(promise).then(data => {
        if (!this._mounted) return;
        this.setState({
          [name]: {
            loading: false,
            data,
            error: null
          }
        });
      }).catch(err => {
        if (!this._mounted) return;
        this.setState({
          [name]: {
            loading: false,
            data: null,
            error: err.message || String(err)
          }
        });
      }).finally(() => {
        pending--;
        if (pending <= 0) this._fetching = false;
      });
    }
  }
  fetchSections() {
    return {};
  }
  get query() {
    var url = location.href;
    var query = {};
    var hu = url.split('?')[1];
    if (typeof hu !== 'undefined') {
      var gy = hu.split("&");
      for (var i = 0; i < gy.length; i++) {
        var ft = gy[i].split("=");
        query[ft[0]] = ft[1];
      }
    }
    return query;
  }
  get queryParams() {
    var search = location.search;
    search = search.replace('?', '');
    return new URLSearchParams(search);
  }
  get page() {
    var page = this.queryParams.get('page');
    if (!page) page = 1;
    return parseInt(page);
  }
  gotoPage(page) {
    PubSub.publish('allow-update', {});
    setTimeout(() => {
      this.props.history.push(page);
    }, 100);
  }
}